<template>
  <div
    id="sidenav-collapse-main"
    class="w-auto h-auto collapse navbar-collapse"
  >
    <ul class="navbar-nav">
      <li
        v-for="(item, index) in conversations"
        :key="item.id || index"
        class="nav-item d-flex justify-content-between align-items-center"
        @click.prevent="$emit('conversation-selected', item.id)"
      >
        <sidenav-collapse
          :conversation-id="item.id"
          :isDeleteMode="isDeleteMode"
          :selectedConversations="selectedConversations"
          :nav-text="truncateBotName(item.text)"
          :collapse="false"
          url="#"
          :aria-controls="''"
          collapse-ref="''"
          @conversation-toggle="$emit('conversation-toggle', $event)"
          @conversation-deleted="$emit('conversation-deleted', $event)"
        >
          <template #icon>
            <ChatIcon />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>
<script>
import SidenavCollapse from './SidenavCollapse.vue'
import { mapState } from 'vuex'
import ChatIcon from '@/components/Icon/ChatIcon.vue'

export default {
  name: 'SidenavList',
  components: {
    ChatIcon,
    SidenavCollapse,
  },
  props: {
    cardBg: {
      type: String,
      default: '',
    },
    conversations: {
      type: Array,
      required: false,
      default: () => [],
    },
    isDeleteMode: Boolean,
    selectedConversations: Array,
  },
  computed: {
    ...mapState(['isRTL']),
  },
  methods: {
    handleClick(botId) {
      if (this.isDeleteMode) {
        this.$emit('conversation-toggle', botId)
      } else {
        this.$emit('conversation-selected', botId)
      }
    },
    getRoute() {
      const routeArr = this.$route.path.split('/')
      return routeArr[1]
    },
    truncateBotName(name) {
      let bytes = 0
      let result = ''

      for (const char of name) {
        const charCode = char.charCodeAt(0)
        bytes += charCode > 255 ? 2 : 1 // 全角:2バイト, 半角:1バイト

        if (bytes > 18) {
          result += '…'
          break
        }
        result += char
      }

      return result
    },
  },
}
</script>
